import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Box } from "@material-ui/core";
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import { Checkboxes } from "../../../FlowConfigurationInputs";
import { CredentialPicker } from '../../../FlowConfigurationInputs/CredentialPicker/CredentialPicker';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

// TabPanel styling
function TabPanel({ children, value, index }) {
  return <div>{value === index && <Box>{children}</Box>}</div>;
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

/**
 * @Description this page Active Directory  Library's Password Reset Action's configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     div element
 * @Author      ibrahim AKIN
 */
export default function PasswordReset({ action, variables, setOpenVariable, variableRender }) {
  const { t } = useTranslation();
  const label = 'CONTENT.CONFIGURATION-FORM.ACTIVE-DIRECTORY.CREATE-USER.';
  const [value, setValue] = useState(0);
  const options = {
    checkboxes: { label: label + 'CHANGE' }
  };
  useEffect(() => {
    if (!action.fields.filter) {
      action.fields.filter = { value: 'username' };
      setValue(0);
    } else {
      setValue(action.fields.filter.value === 'username' ? 0 : 1)
    }
  }, [action, variables]);

  const handleChange = (newValue) => {
    if (newValue === 0) {
      action.fields.filter.value = 'username';
    } else { action.fields.filter.value = 'logonname'; }
    setValue(newValue);
  };
  return (
    <>
      <div className="conf-field-container">
        <div className="condition-tabs">
          <button
            className={`f-s-11 ${value === 0 ? 'condition-active' : ''}`}
            onClick={() => handleChange(0)}>
            {t(label + "USERNAME")}
          </button>
          <button
            className={`f-s-11 ${value === 1 ? 'condition-active' : ''}`}
            onClick={() => handleChange(1)}>
            {t(label + "LOGON-NAME")}
          </button>
        </div>
        <TabPanel value={value} index={0}>
          <TextInput
            action={action}
            isRequired={false}
            inputName="userName"
            variables={variables}
            setOpenVariable={setOpenVariable}
            variableRender={variableRender}
            fieldType="string"
            displayName={t(label + "USERNAME")}
          />
          <small className="conf-field-desc">{"{eg:JohnBrown }"}</small>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <TextInput
            action={action}
            isRequired={false}
            inputName="logonName"
            variables={variables}
            setOpenVariable={setOpenVariable}
            variableRender={variableRender}
            fieldType="string"
            displayName={t(label + "LOGON-NAME")}
          />
          <small className="conf-field-desc">{"{eg:johnbrown }"}</small>
        </TabPanel>
      </div>
      <div className="conf-field-container">
        <FieldLabel name={t(label + 'PASSWORD')} is_required={true} />
        <CredentialPicker action={action} inputName="password" variables={variables} setOpenVariable={setOpenVariable} isRequired hideRequired={true} isPassword={true} />
      </div>
      <div className="conf-field-container">
        <Checkboxes action={action} inputName="mustBeChange" options={options.checkboxes} />
      </div>
    </>
  );
}